import { Link, useLocation } from "react-router-dom";
import React, { useContext, useState, useRef, useEffect } from "react";
import { AuthContext } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

function NavLink({ to, label }) {
  const location = useLocation();
  const isActive = location.pathname === to;

  return (
    <li className="nav-item" style={{ flexShrink: 0, minWidth: "fit-content" }}>
      <Link
        className={`nav-link ${isActive ? "active" : ""}`}
        style={{
          color: isActive ? "#ffc414" : "white",
          whiteSpace: "nowrap",
          fontWeight: isActive ? "bold" : "normal",
          fontFamily: "'Bahnschrift Condensed', 'Arial Narrow', Arial, sans-serif",
          fontSize: "18px",
        }}
        to={to}
        aria-current={isActive ? "page" : undefined}
      >
        {label}
      </Link>
    </li>
  );
}

export function Navbar() {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const [reportsDropdownOpen, setReportsDropdownOpen] = useState(false);
  const [processDropdownOpen, setProcessDropdownOpen] = useState(false);
  const reportsDropdownRef = useRef(null);
  const processDropdownRef = useRef(null);

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (reportsDropdownRef.current && !reportsDropdownRef.current.contains(event.target)) {
        setReportsDropdownOpen(false);
      }
      if (processDropdownRef.current && !processDropdownRef.current.contains(event.target)) {
        setProcessDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [reportsDropdownRef, processDropdownRef]);

  const navbarTogglerStyle = {
    backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 1%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e")`,
  };

  return (
    <>
      <nav
        className="navbar navbar-expand-lg border-bottom box-shadow"
        style={{
          backgroundColor: "#133E87",
          position: "sticky",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1000,
          paddingRight: "45px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
          <div style={{ width: "240px", height: "55px", paddingTop: "5px" }}>
            <Link className="navbar-brand" to="/" style={{ color: "white", paddingLeft: "30px", fontFamily: "'Calibri (Body)'", fontSize: "32px" }}>
              <img src="/eicon32.png" alt="..." style={{ marginTop: "-5px", paddingRight: "5px" }} />      
              Easyenjaz        
            </Link>
          </div>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
            style={{ marginLeft: "auto" }}
          >
            <span className="navbar-toggler-icon" style={navbarTogglerStyle}></span>
          </button>
        </div>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0 align-items-center" style={{ gap: "1rem" }}>
            <NavLink to="/" label="HOME" />
            <span className="text-white d-none d-lg-inline" style={{ verticalAlign: "middle" }}>|</span>
            {user && (user.role?.includes("AGENCY") || user.role?.includes("OWNER") || user.role?.includes("ADMIN") || user.role?.includes("STAFF") || user.role?.includes("POWERADMIN")) && (
              <>
                <NavLink to="/applicants/create" label="NEW APPLICATION" />
                <span className="text-white d-none d-lg-inline" style={{ verticalAlign: "middle" }}>|</span>
              </>              
            )}

            {user && (user.role?.includes("AGENCY") || user.role?.includes("OWNER") || user.role?.includes("ADMIN") || user.role?.includes("STAFF") || user.role?.includes("POWERADMIN")) && (
              <>
                <NavLink to="/applicants/applicantlist" label="APPLICANTS" />
                <span className="text-white d-none d-lg-inline" style={{ verticalAlign: "middle" }}>|</span>
              </>
            )}

            {user && (user.role?.includes("AGENT")  || user.role?.includes("FOREIGN AGENT") || user.role?.includes("FOREIGN AGENT")) && (
              <>
                <NavLink to="/applicants/agent_applicants" label="APPLICANTS" />
                <span className="text-white d-none d-lg-inline" style={{ verticalAlign: "middle" }}>|</span>
              </>
            )}            

            {user && user.role?.includes("POWERADMIN") && (
              <>
                <NavLink to="/coupons/couponslist" label="COUPONS" />
                <span className="text-white d-none d-lg-inline" style={{ verticalAlign: "middle" }}>|</span>
                <NavLink to="/companies/companylist" label="COMPANY" />
                <span className="text-white d-none d-lg-inline" style={{ verticalAlign: "middle" }}>|</span>
              </>
            )}
            {user && user.role?.includes("FOREIGN AGENT") && (
              <>
                <NavLink to="/applicants/gallery" label="GALLERY" />
                <span className="text-white d-none d-lg-inline" style={{ verticalAlign: "middle" }}>|</span>
              </>
            )}

            {user && (user.role?.includes("AGENCY") || user.role?.includes("OWNER") || user.role?.includes("ADMIN") || user.role?.includes("STAFF") || user.role?.includes("POWERADMIN")) && (
              <>
                <NavLink to="/flights/flightlist" label="FLIGHT" />
                <span className="text-white d-none d-lg-inline" style={{ verticalAlign: "middle" }}>|</span>

                {/* PROCESS Dropdown */}
                <li className="nav-item dropdown" ref={processDropdownRef}>
                  <button
                    className="nav-link dropdown-toggle text-white bg-transparent border-0 es-tab-title"
                    role="button"
                    onClick={() => setProcessDropdownOpen(!processDropdownOpen)}
                    style={{
                      color: "white",
                      whiteSpace: "nowrap",
                      fontWeight: "normal",
                      fontFamily: "'Bahnschrift Condensed', 'Arial Narrow', Arial, sans-serif",
                      fontSize: "18px",
                    }}
                  >
                    PROCESS
                  </button>
                  <ul className={`dropdown-menu ${processDropdownOpen ? "show" : ""}`}>
                    <li>
                      <Link
                        className="dropdown-item es-dropdown-item"
                        to="/applicants/applicantsTrack/registered"
                        onClick={() => setProcessDropdownOpen(false)}
                      >
                        REGISTERED
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item es-dropdown-item"
                        to="/applicants/applicantsTrack/available"
                        onClick={() => setProcessDropdownOpen(false)}
                      >
                        AVAILABLE
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item es-dropdown-item"
                        to="/applicants/applicantsTrack/cv-sent"
                        onClick={() => setProcessDropdownOpen(false)}
                      >
                        CV-SENT
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item es-dropdown-item"
                        to="/applicants/applicantsTrack/selected"
                        onClick={() => setProcessDropdownOpen(false)}
                      >
                        SELECTED
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item es-dropdown-item"
                        to="/applicants/applicantsTrack/ashara"
                        onClick={() => setProcessDropdownOpen(false)}
                      >
                        ASHARA
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item es-dropdown-item"
                        to="/applicants/applicantsTrack/in-embassy"
                        onClick={() => setProcessDropdownOpen(false)}
                      >
                        IN-EMBASSY
                      </Link>
                    </li>
                    
                    <li>
                      <Link
                        className="dropdown-item es-dropdown-item"
                        to="/applicants/applicantsTrack/visa-stamped"
                        onClick={() => setProcessDropdownOpen(false)}
                      >
                        VISA STAMPED
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item es-dropdown-item"
                        to="/applicants/applicantsTrack/lmis"
                        onClick={() => setProcessDropdownOpen(false)}
                      >
                        LMIS
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item es-dropdown-item"
                        to="/applicants/applicantsTrack/ticket-booked"
                        onClick={() => setProcessDropdownOpen(false)}
                      >
                        TICKET BOOKED
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item es-dropdown-item"
                        to="/applicants/applicantsTrack/traveled"
                        onClick={() => setProcessDropdownOpen(false)}
                      >
                        TRAVELLED
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item es-dropdown-item"
                        to="/applicants/applicantsTrack/payment-request"
                        onClick={() => setProcessDropdownOpen(false)}
                      >
                        PAYMENT REQUEST
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item es-dropdown-item"
                        to="/applicants/applicantsTrack/paid"
                        onClick={() => setProcessDropdownOpen(false)}
                      >
                        PAID
                      </Link>
                    </li>
                  </ul>
                </li>

                <span className="text-white d-none d-lg-inline" style={{ verticalAlign: "middle" }}>|</span>

                {/* Reports Dropdown */}
                <li className="nav-item dropdown" ref={reportsDropdownRef}>
                  <button
                    className="nav-link dropdown-toggle text-white bg-transparent border-0 es-tab-title"
                    role="button"
                    onClick={() => setReportsDropdownOpen(!reportsDropdownOpen)}
                    style={{
                      color: "white",
                      whiteSpace: "nowrap",
                      fontWeight: "normal",
                      fontFamily: "'Bahnschrift Condensed', 'Arial Narrow', Arial, sans-serif",
                      fontSize: "18px",
                    }}
                  >
                    REPORTS
                  </button>
                  <ul className={`dropdown-menu ${reportsDropdownOpen ? "show" : ""}`}>
                    <li>
                      <Link
                        className="dropdown-item es-dropdown-item"
                        to="/applicants/inactive-applicants"
                        onClick={() => setReportsDropdownOpen(false)}
                      >
                        Inactive Applicants
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item es-dropdown-item"
                        to="/applicants/applicantListAG"
                        onClick={() => setReportsDropdownOpen(false)}
                      >
                        Applicant List
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item es-dropdown-item"
                        to="/complains/complainlist"
                        onClick={() => setReportsDropdownOpen(false)}
                      >
                        Complains
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item es-dropdown-item"
                        to="/filters/citizens-condition"
                        onClick={() => setReportsDropdownOpen(false)}
                      >
                        Citizens Condition
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item es-dropdown-item"
                        to="/filters/ethiopianOverseas"
                        onClick={() => setReportsDropdownOpen(false)}
                      >
                        Ethiopian Overseas Workers
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item es-dropdown-item"
                        to="/filters/issuedLmisApplicants"
                        onClick={() => setReportsDropdownOpen(false)}
                      >
                        Issued Applicants In LMIS
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item es-dropdown-item"
                        to="/filters/applicantsDetail"
                        onClick={() => setReportsDropdownOpen(false)}
                      >
                        Applicants Detail
                      </Link>
                    </li>
                    <li>
                    <Link
                        className="dropdown-item es-dropdown-item"
                        to="/commissions/list"
                        onClick={() => setReportsDropdownOpen(false)}
                      >
                        Commission List
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item es-dropdown-item"
                        to="/reports/applicants-gallery"
                        onClick={() => setReportsDropdownOpen(false)}
                      >
                        Applicants Gallery
                      </Link>
                    </li>
                  </ul>
                </li>

                <span className="text-white d-none d-lg-inline" style={{ verticalAlign: "middle" }}>|</span>
                <NavLink to="/defaultsettings/create" label="SETTINGS" />
                <span className="text-white d-none d-lg-inline" style={{ verticalAlign: "middle" }}>|</span>
              </>
            )}
          </ul>

          <ul className="navbar-nav align-items-center" style={{ flexShrink: 0, paddingLeft: "30px" }}>
            {user ? (
              // Display dropdown when user is logged in
              <li className="nav-item dropdown">
                <button
                  className="nav-link dropdown-toggle text-white bg-transparent border-0 es-tab-title"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {user.username || "USERNAME"}
                </button>
                <ul className="dropdown-menu">
                  <li>
                    <Link className="dropdown-item es-dropdown-item" to="/accounts/manageaccounts">
                      SETTINGS
                    </Link>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <Link className="dropdown-item es-dropdown-item" to="/" onClick={handleLogout}>
                      Logout
                    </Link>
                  </li>
                </ul>
              </li>
            ) : (
              // Display login button when user is not logged in
              <li className="nav-item">
                <Link className="nav-link text-white es-tab-title" to="/login">
                  Login
                </Link>
              </li>
            )}
          </ul>
        </div>
      </nav>

      
    </>
  );
}

export function Footer() {
    return (
        <footer>
            <div className="border-top p-4" style={{ backgroundColor: "#ebedf0" }}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-4 mb-4">
                            <h5>Central Agent</h5>
                            <p>
                                An online registration process must be completed in addition to your visa application form. You must sign and date the Easycujax Registration Release Form found in this kit.
                            </p>
                        </div>

                        <div className="col-md-4 mb-8">
                            <h5>Quick Links</h5>
                            <ul className="list-unstyled">
                                <li><a href="https://visa.mofa.gov.sa/Account/Login/enjazcompany" className="text-decoration-none es-weblink" target="_blank">Enjaizit: Kingdom of Saudi Arabia Visa</a></li>
                                <li><a href="https://tawtheeq.musaned.com.sa/" className="text-decoration-none es-weblink" target="_blank">Musaned: Domestic Labour Service</a></li>
                                <li><a href="https://lmis.gov.et/auth" className="text-decoration-none es-weblink" target="_blank">Ethiopian Labor Market Information System</a></li>
                                <li><a href="https://wafid.com/book-appointment/" className="text-decoration-none es-weblink" target="_blank">Wafdi: Medical Examinations</a></li>
                                <li>
                                  <a href="https://lmis.gov.et/coc-check" className="text-decoration-none es-weblink" target="_blank">Federal COC</a> |  
                                  <a href="https://verify.ococ.gov.et/" className="text-decoration-none es-weblink" target="_blank"> Oromia COC</a> | 
                                  <a href="https://www.amharacoc.gov.et/code/certificate.html" className="text-decoration-none es-weblink" target="_blank"> Amhara COC</a> | 
                                  <a href="https://www.snnprocaa.gov.et/" className="text-decoration-none es-weblink" target="_blank"> SNNP COC</a>
                                </li>
                            </ul>
                        </div>

                        <div className="col-md-4 mb-4">
                            <h5>Contact Us</h5>
                            <ul className="list-unstyled">
                                <li>Phone: +251 911 454176</li>
                                <li>Mail: easyenjaz.sa@gmail.com</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div className="text-center py-3" style={{ backgroundColor: "#133E87", color: "white" }}>
                <p className="mb-0">{new Date().getFullYear()} © All Rights Reserved.</p>
            </div>
        </footer>
    );
}